import { useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import { FormRenderer } from "./FormRenderer";
import { fetchFormConfiguration } from "./resources";

interface FormLoaderProps {
  api: AxiosInstance;
  config: any;
  context: any;
}

export const FormLoader = ({ api, config, context }: FormLoaderProps) => {
  const schemaQuery = useQuery({
    queryKey: ["formSchema", config.formId],
    queryFn: async () => fetchFormConfiguration(api, config.formId),
    structuralSharing: (prev, next) => {
      const prevData = prev as { etag?: string | null } | undefined;
      const nextData = next as { etag?: string | null };
      if (prevData && prevData.etag === nextData.etag) {
        return prev;
      }
      return next;
    },
  });

  if (schemaQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (schemaQuery.isError) {
    return <div>Error loading form configuration.</div>;
  }

  return <FormRenderer schema={schemaQuery.data} api={api} context={context} />;
};
